import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  shippingServiceWeightRuleName: {
    description: 'Default rule name for the shipping service weight playbook rule template',
    defaultMessage: 'Ground Advantage <16 oz',
    id: 'vFomyy',
  },
  shippingServiceWeightTitle: {
    description: 'Card title for the shipping service by weight automation playbook',
    defaultMessage: 'Set Shipping Service Based on Weight',
    id: 'nYgHlH',
  },
  shippingServiceWeightDescription: {
    description: 'Card description for the shipping service by weight automation playbook',
    defaultMessage: 'Automatically select the best service based on package weight.',
    id: 'CKiuxX',
  },
  insureOrdersRuleName: {
    description: 'Default rule name for the insure orders playbook rule template',
    defaultMessage: 'Insure Packages',
    id: 'JJcgPP',
  },
  insureOrdersTitle: {
    description:
      'Card title for the insure orders automation playbook. {insuranceProvider} is the name of the insurance provider, e.g. ParcelGuard or Total Shipping Protection',
    defaultMessage: 'Insure Orders with {insuranceProvider}',
    id: 'lFnMz2',
  },
  insureOrdersDescription: {
    description: 'Card description for the insure orders automation playbook',
    defaultMessage: 'Insure your shipments based on weight, value, or other criteria.',
    id: 'wYUMgz',
  },
  rateShopperRuleName: {
    description: 'Default rule name for the marketplace rate shopper playbook rule template',
    defaultMessage: 'Marketplace Specific Rate Shopper',
    id: 'IcCigZ',
  },
  rateShopperTitle: {
    description: 'Card title for the marketplace rate shopper automation playbook',
    defaultMessage: 'Marketplace Specific Rate Shopper',
    id: 'aRXn8e',
  },
  rateShopperDescription: {
    description: 'Card description for the marketplace rate shopper automation playbook',
    defaultMessage: 'Automatically choose the lowest-cost shipping option that still meets your delivery promises/SLAs.',
    id: 'GOlZva',
  },
  state48ShippingRuleName: {
    description: 'Default rule name for the state-based shipping service playbook rule template excluding Alaska and Hawaii',
    defaultMessage: 'Set Shipping Service Based on State - 48 States',
    id: 'QjCi0V',
  },
  state48ShippingTitle: {
    description: 'Card title for the state-based shipping service automation playbook',
    defaultMessage: 'Set Shipping Service Based on State - 48 States',
    id: 'nQQuiP',
  },
  state48ShippingDescription: {
    description: 'Card description for the state-based shipping service automation playbook',
    defaultMessage: 'Automatically apply shipping services based on destination state USPS Ground Advantage.',
    id: 'DSlCNo',
  },
  alohaStateShippingRuleName: {
    description: 'Default rule name for the state-based shipping service playbook rule template for Alaska and Hawaii',
    defaultMessage: 'Set Shipping Service Based on State - Priority Mail',
    id: 'U4GZwV',
  },
  alohaStateShippingTitle: {
    description: 'Card title for the Alaska and Hawaii state-based shipping service automation playbook',
    defaultMessage: 'Set Shipping Service Based on State - HI & AK',
    id: 'wqbw+S',
  },
  alohaStateShippingDescription: {
    description: 'Card description for the Alaska and Hawaii state-based shipping service automation playbook',
    defaultMessage: 'Set shipping services for non-mainland destination addresses to USPS Priority Mail.',
    id: '1FTnJb',
  },
  shipFromStoreRuleName: {
    description: 'Default rule name for the ship from store playbook rule template',
    defaultMessage: 'Orders from [Store Name] route to [ShipFrom Name]',
    id: '52w+5m',
  },
  shipFromStoreTitle: {
    description: 'Card title for the ship from store automation playbook',
    defaultMessage: 'Set Ship From Address Based on Store',
    id: 'Rjo4rw',
  },
  shipFromStoreDescription: {
    description: 'Card description for the ship from store automation playbook',
    defaultMessage: 'Automatically set ship from location based on store.',
    id: 'qyfpZW',
  },
  residentialShippingRuleName: {
    description: 'Default rule name for the residential address shipping playbook rule template',
    defaultMessage: 'FedEx Home Delivery for Residential Addresses',
    id: 'GVYBMD',
  },
  residentialShippingTitle: {
    description: 'Card title for the residential address shipping automation playbook',
    defaultMessage: 'Match Services to Residential Addresses',
    id: 'PL+6uU',
  },
  residentialShippingDescription: {
    description: 'Card description for the residential address shipping automation playbook',
    defaultMessage: 'Set a default shipping service for residential addresses.',
    id: 'osvJGl',
  },
  commercialShippingRuleName: {
    description: 'Default rule name for the commercial address shipping playbook rule template',
    defaultMessage: 'FedEx Ground for Commercial Addresses',
    id: 'PkpOnS',
  },
  commercialShippingTitle: {
    description: 'Card title for the commercial address shipping automation playbook',
    defaultMessage: 'Match Services to Commercial Addresses',
    id: 'r28kyG',
  },
  commercialShippingDescription: {
    description: 'Card description for the commercial address shipping automation playbook',
    defaultMessage: 'Set a default shipping service for commercial addresses.',
    id: 'WONO5Q',
  },
  orderTagShippingRuleName: {
    description: 'Default rule name for the order tag shipping playbook rule template',
    defaultMessage: 'Set Carrier/Service/Package by Order Tag',
    id: 'F3i2CG',
  },
  orderTagShippingTitle: {
    description: 'Card title for the order tag shipping automation playbook',
    defaultMessage: 'Set Service Based On Order Tags',
    id: 'jNMtjB',
  },
  orderTagShippingDescription: {
    description: 'Card description for the order tag shipping automation playbook',
    defaultMessage: 'Automatically choose the lowest-cost shipping option that still meets your delivery promises/SLAs.',
    id: 'Lcf8K5',
  },
  previewTemplate: {
    description: 'Button label to preview and open an automation playbook template in the rule editor',
    defaultMessage: 'Preview Template',
    id: 'H3dqYH',
  },
});
